<template>
  <div class="performance-analysis_page">
    <div v-if="Object.keys(analysisInfo).length && analysisInfo.behavior" class="analysis-content">
      <template v-if="pageDescList.length">
        <div v-for="(item, index) in pageDescList" :key="index" class="desc-item">
          <span>{{ item[0] }}:</span>
          {{ item[1] }}
        </div>
      </template>
      <div class="ai-suggestion">
        <div class="title">
          <img alt="boss" class="icon" :src="suggestionTitle.avatar" />
          <span class="name">{{ suggestionTitle.name }} 建议</span>
        </div>
        <!-- <div class="ai-suggestion-item">
          <span class="dot"></span> -->
        <p v-for="(subItem, j) in aiSuggestionData" :key="j">
          {{ subItem }}
        </p>
        <!-- </div> -->
      </div>
    </div>
    <template v-else>
      <Empty :empty-text="emptyText" />
    </template>
  </div>
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import aiLogo from '@/assets/ai-logo.png'
import boss from '@/assets/boss.png'
import Empty from '@/components/Empty/index.vue'
import utils from '@/utils'

defineOptions({
  name: 'PerformanceAnalysis'
})
const props = defineProps({
  analysisInfo: {
    type: Object,
    default: () => ({})
  },
  status: {
    type: [String, Number],
    default: ''
  },
  hasEnableRule: {
    type: Number,
    default: 1
  }
})

// 建议标题
const suggestionTitle = computed(() => {
  return utils.xbbLocalStorageGet('expertBossEnable')
    ? {
        name: '王钊琦',
        avatar: boss
      }
    : {
        name: 'AI',
        avatar: aiLogo
      }
})
const emptyText = computed(() => {
  if (props.status === 1) {
    return '正在分析中，预计1-2min，无需在此等待'
  }
  if (!props.hasEnableRule) {
    return '暂无匹配的员工表现分析规则，无法生成 AI 分析'
  }
  return '本次会话未提炼到员工表现'
})

const pageDescList = computed(() => {
  return Object.entries(props.analysisInfo?.behavior || {}) || []
})

const aiSuggestionData = computed(() => {
  return props.analysisInfo?.aiASuggestion?.split('\n') || ''
})
</script>

<style lang="scss" scoped>
.performance-analysis_page {
  margin-top: 8px;
  color: #323233;
  min-height: 212px;
  flex: 1;
  .analysis-content {
    padding: 12px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    .desc-item {
      display: flex;
      & > span {
        flex-shrink: 0;
        margin-right: 5px;
      }
    }
  }
  .ai-suggestion {
    padding: 12px;
    background: #f7f8fa;
    border-radius: 8px;
    border: 1px solid #e5e6eb;
    margin-top: 16px;
    .ai-suggestion-item {
      display: flex;
      overflow: hidden;
      .dot {
        flex-shrink: 0;
        width: 3px;
        height: 3px;
        margin-top: 10px;
        background: #323233;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
  .icon {
    margin-right: 9px;
    width: 20px;
    height: 20px;
  }
  .name {
    font-weight: 600;
    position: relative;
    top: 2px;
  }
  .title {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
}
</style>
